import React from "react";
import Meta from "./../components/Meta";
import { useLocation } from "./../util/router";

function NotFoundPage(props) {
  const location = useLocation();

  return (
    <>
      <Meta title="404" />
      <div
        style={{
          padding: "50px",
          width: "100%",
          textAlign: "center",
        }}
      >
        The page <code>{location.pathname}</code> could not be found
      </div>
    </>
  );
}

export default NotFoundPage;
